"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _fns = require("@react-pdf/fns");
/**
 * Return glyph index at string index, if glyph indices present.
 * Otherwise return string index
 *
 * @param  {number}  string index
 * @param  {Object}  run
 * @return {number}  glyph index
 */


var glyphIndexAt = function glyphIndexAt(index, run) {
  var _run$glyphIndices;

  var result = run === null || run === void 0 ? void 0 : (_run$glyphIndices = run.glyphIndices) === null || _run$glyphIndices === void 0 ? void 0 : _run$glyphIndices[index];
  return (0, _fns.isNil)(result) ? index : result;
};

var _default = glyphIndexAt;
exports["default"] = _default;